import {config} from "./config";
import api from "./axios";

/******** NON-AUTHENTICATION METHODS ********/

export const GetPortalStatusAPI = (utype) => {
	const method = 'PortalStatus';
	return api.get(
		config.api+'?method='+method+'&utype='+utype
	);
};

export const LoginAPI = (data, customUtype = null) => {
	const method = 'Login';
	const utypeToUse = customUtype || config.utype || localStorage.getItem('utype');
	return api.post(
		config.api+'?method='+method+'&utype='+utypeToUse,
		JSON.stringify(data)
	);
}

export const RegisterAPI = (data) => {
	const method = 'Register';
	return api.post(
		config.api+'?method='+method+'&utype='+(config.utype || localStorage.getItem('utype')),
		JSON.stringify(data)
	);
};

export const VerificationCodeAPI = (data) => {
	const method = 'VerificationCode';
	return api.post(
		config.api+'?method='+method+'&utype='+(config.utype || localStorage.getItem('utype')),
		JSON.stringify(data)
	);
};

export const ForgotPasswordAPI = (data) => {
	const method = 'ForgotPassword';
	return api.post(
		config.api+'?method='+method+'&utype='+(config.utype || localStorage.getItem('utype')),
		JSON.stringify(data)
	);
};

export const SendConfirmCodeAPI = (data) => {
	// let method = '';
	// return api.post(
	//	config.api+'?method='+method+'&utype='+config.utype,
	// 	data
	// );
};

export const ChangePasswordAPI = (data) => {
	const method = 'ChangePassword';
	return api.post(
		config.api+'?method='+method+'&utype='+(config.utype || localStorage.getItem('utype')),
		JSON.stringify(data)
	);
};

/******** AUTHENTICATION METHODS ********/

export const GetPortalSettingsAPI = () => {
	const method = 'GetPortalSettings';
	return api.get(
		config.api+'?method='+method
	);
}

export const GetUserInfoAPI = () => {
	const method = 'GetUserInfo';
	return api.get(
		config.api+'?method='+method
	);
};

export const SetPortalPreferencesAPI = (data) => {
	const method = 'SetPortalPreferences';
	return api.post(
		config.api+'?method='+method,
		JSON.stringify(data)
	);
};

export const GetEntryAPI = (data) => {
	const method = 'Retrieve';
	return api.post(
		config.api+'?method='+method,
		JSON.stringify(data)
	);
};

export const CreateAPI = (data, module) => {
	const method = 'Save';
	return api.post(
		config.api+'?method='+method+'&module='+module,
		data
	);
};


export const CallCustomAPI = (method, data) => {
	return api.post(
		config.api+'?method='+method,
		data
	);
};


export const UpdateAPI = (data, module, id) => {
	const method = 'Save';
	return api.put(
		config.api+'?method='+method+'&module='+module+"&id="+id,
		data
	);
};

export const SaveAPI = (data, module, id='') =>
{
	if(id !== '')
	{
		return UpdateAPI(data, module, id);
	}
	else
	{
		return CreateAPI(data, module);
	}
};

export const DeleteAPI = (module, id) =>
{
	const method = 'Save';
	return api.delete(
		config.api+'?method='+method+'&module='+module+"&id="+id
	);
};

export const GetModuleListAPI = (module, data) => {
	const method = 'Retrieve';
	const payload = Object.assign({}, data, { include_count: true });
	return api.post(
		config.api+'?method='+method+'&module='+module,
		JSON.stringify(payload)
	);
};

export const GetSSRSReportAPI = (id, parentID='', parameters={}) => {
	const method = 'GetSSRSReport';
	let url = config.api+'?method='+method+'&id='+id+(parentID.length ? '&parent_id='+parentID : '');
	if(Object.keys(parameters).length)
	{
		url += '&parameters='+encodeURIComponent(JSON.stringify(parameters));
	}
	return api.get(url);
};

export const CheckHasManualParameterAPI = (id, parentID='') => {
	const method = 'CheckHasManualParameter';
	return api.get(
		config.api+'?method='+method+'&id='+id+(parentID.length ? '&parent_id='+parentID : ''),
	);
};

export const UploadFileAPI = (formData, Callback) => {
	const method = 'Upload';
	return api.post(
		config.api+'?method='+method,
		formData,
		{
			headers: {'Content-Type': 'multipart/form-data'},
			onUploadProgress: (progressEvent) =>
			{
				if(Callback)
				{
					let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
					Callback(percentCompleted);
				}
			}
		}
	);
};

export const DownloadFileAPI = (id) => {
	const method = 'Download';
	return api.get(
		config.api+'?method='+method+'&id='+id,
	);
};

export const GeneratePdfAPI = (id, module) => {
	const method = 'GeneratePDF';
	return api.get(
		config.api+'?method='+method+'&module='+module+'&id='+id,
	);
};

export const FileContentAPI = (id) => {
	const method = 'Download';
	return api.get(
		config.api+'?method='+method+'&id='+id+'&content=true',
	);
};

export const RemoveFileAPI = (id) => {
	const method = 'RemoveFile';
	return api.delete(
		config.api+'?method='+method+'&id='+id,
	);
};

export const FetchDropdownAPI = (data) => {
	const method = 'FetchDropdown';
	return api.get(
		config.api+'?method='+method+'&type='+data.type+'&key='+data.key
	);
}

export const GetDashletAPI = (data) => {
	const method = 'GetDashletData';
	return api.get(
		config.api+'?method='+method+'&module='+data.module+'&name='+data.name
	);
}

export const GetRelationshipAPI = (data) => {
	const method = 'GetRelationship';
	return api.post(
		config.api+'?method='+method,
		JSON.stringify(data)
	);
};

export const UnifiedSearchAPI = (data) => {
	const method = 'UnifiedSearch';
	return api.post(
		config.api+'?method='+method,
		JSON.stringify(data)
	);
};

export const GetNotificationAPI = (data) => {
	const method = 'GetNotifications';
	return api.post(
		config.api+'?method='+method,
		JSON.stringify(data)
	);
};

export const TransferToGatewayAPI = (data) => {
	const method = 'TransferToGateway';
	return api.post(
		config.api+'?method='+method,
		JSON.stringify(data)
	);
};

export const GetProductsOfBundle = (data) => {
	const method = 'GetProductsOfBundle';
	return api.post(
		config.api+'?method='+method,
		JSON.stringify(data)
	);
};

export const SurveyResponseQuestionsAPI = (data) => {
	const method = 'surveyResponseQuestions';
	return api.post(
		config.api+'?method='+method,
		JSON.stringify(data)
	);
};

export const SurveyResponseSaveAnswersAPI = (data) => {
	const method = 'surveyResponseSaveAnswers';
	return api.post(
		config.api+'?method='+method,
		JSON.stringify(data)
	);
};

export const GetPreSigendURL = (data) => {
	const method = 'GenerateURL';
	return api.post(
		config.api+'?method='+method,
		JSON.stringify(data)
	);
};

export const AfterUploadVideo = (data) => {
	const method = 'AfterUploadVideo';
	return api.post(
		config.api+'?method='+method,
		JSON.stringify(data)
	);
};

export const CloseTicketAPI = (data, module, id) => {
	const method = 'CloseTicket';
	return api.put(
		config.api+'?method='+method+'&module='+module+"&id="+id,
		data
	);
};
